/**
 * JavaScript Utility - string/repeat
 * @author 서명환 <mhseo@ulalalab.com>
 */
function repeat(pattern, count, sep = '') {
  return new Array(Math.max(0, count)).fill(pattern).join(sep);
}

export default repeat;
